module.exports = __webpack_public_path__ + "static/img/race2020-2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/race2020-2.jpg
// module id = /gjD
// module chunks = 0